export const APP_NAME = 'Cycle';

export const PAGE_TITLE_SEPARATOR = ' • ';
